export const BASE_URL_SERVICE = "https://rememberme.agrorecomenda.com/api/v1/";
